import '../framework/tea';
function sendV3ByToutiao(env, event, params) {
    var UMENG_EVENT_TYPE = 'log_event_v3';
    var s = 'bytedance://' + UMENG_EVENT_TYPE + '?event=' + event;
    if (params) {
        try {
            s += '&params=' + encodeURIComponent(JSON.stringify(params));
        }
        catch (e) {
            console.log(e);
        }
    }
    try {
        window.webkit.messageHandlers.observe.postMessage(s);
    }
    catch (err) {
        console.log(s);
    }
}
function sendLogV3ByUmeng(env, event, params) {
    var obj = {
        category: 'event_v3',
        tag: event,
        extra: ''
    };
    try {
        obj.extra = JSON.stringify(params);
    }
    catch (e) {
        console.log(e);
    }
    var s = 'bytedance://' + (env.isAndroid ? 'log_event?' : 'custom_event?');
    if (obj) {
        s += Object.keys(obj).reduce(function (acc, item) {
            var prefix = !acc ? '' : acc + '&';
            return (prefix +
                encodeURIComponent(item) +
                '=' +
                encodeURIComponent(obj[item]));
        }, '');
    }
    try {
        window.webkit.messageHandlers.observe.postMessage(s);
    }
    catch (err) {
        console.log(s);
    }
}
function sendLogByTea(env, event, params) {
    window.collectEvent(event, params);
}
export var sendFunConfigInApp = {
    toutiao: {
        canUse: function (env) { return env.isInToutiao || env.isInToutiaoLite; },
        func: sendV3ByToutiao
    },
    // sendLogByJsb: {
    //     canUse: (env: IEnv) => logV3Support(env),
    //     func: sendLogV3ByJsb
    // },
    sendUmengV3: {
        canUse: function (env) { return true; },
        func: sendLogV3ByUmeng
    }
};
export var sendFunConfigOutApp = {
    outApp: {
        canUse: function (env) { return !!window.collectEvent; },
        func: sendLogByTea
    }
};
